/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule, } from '@angular/material/button';
import { MatButtonToggleModule, } from '@angular/material/button-toggle';
import { MatCardModule, } from '@angular/material/card';
import { MatCheckboxModule, } from '@angular/material/checkbox';
import { MatChipsModule, } from '@angular/material/chips';
import { MatDatepickerModule, } from '@angular/material/datepicker';
import { MatDialogModule, } from '@angular/material/dialog';
import { MatExpansionModule, } from '@angular/material/expansion';
import { MatFormFieldModule, } from '@angular/material/form-field';
import { MatGridListModule, } from '@angular/material/grid-list';
import { MatIconModule, } from '@angular/material/icon';
import { MatInputModule, } from '@angular/material/input';
import { MatListModule, } from '@angular/material/list';
import { MatMenuModule, } from '@angular/material/menu';
import { MatPaginatorModule, } from '@angular/material/paginator';
import { MatProgressBarModule, } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule, } from '@angular/material/progress-spinner';
import { MatRadioModule, } from '@angular/material/radio';
import { MatSelectModule, } from '@angular/material/select';
import { MatSidenavModule, } from '@angular/material/sidenav';
import { MatSliderModule, } from '@angular/material/slider';
import { MatSlideToggleModule, } from '@angular/material/slide-toggle';
import { MatSnackBarModule, } from '@angular/material/snack-bar';
import { MatSortModule, } from '@angular/material/sort';
import { MatTableModule, } from '@angular/material/table';
import { MatTabsModule, } from '@angular/material/tabs';
import { MatToolbarModule, } from '@angular/material/toolbar';
import { MatTooltipModule, } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { ObserversModule } from '@angular/cdk/observers';
import { PortalModule } from '@angular/cdk/portal';

/**
 * NgModule that includes all Material modules that are required to serve the demo-app.
 */
@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTableModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    CdkTableModule,
    A11yModule,
    BidiModule,
    CdkAccordionModule,
    ObserversModule,
    OverlayModule,
    PlatformModule,
    PortalModule,
  ]
})
export class DemoMaterialModule { }
